export enum EEditProfileFormItem {
    FIRST_NAME = "first-name",
    LAST_NAME = "last-name",
    EMAIL = "email",
    PHONE = "phone",
}
